
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"#0D69D5","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_106_1747)"}},[_c('path',{attrs:{"d":"M20.27 21.976a2.643 2.643 0 01-3.72.016l-2.846-2.849a2.649 2.649 0 01-.224-3.468l3.534-4.693-4.698 3.538c-1.03.797-2.52.7-3.449-.224l-2.781-2.784a2.65 2.65 0 01-.72-2.395 2.611 2.611 0 011.606-1.913L24.402.18a2.62 2.62 0 011.9-.005A2.63 2.63 0 0127.77 1.56c.289.647.31 1.368.054 2.03L20.852 21.1c-.134.326-.32.614-.566.86l-.016.016zM7.372 9.09a.791.791 0 00-.005 1.117l2.776 2.78c.278.272.72.299 1.041.053l8.317-6.258c.422-.359 1.11-.321 1.56.133.448.45.49 1.139.095 1.604l-6.22 8.268a.798.798 0 00.06 1.052l2.84 2.844c.304.299.811.294 1.126-.022h.005a.918.918 0 00.177-.272L26.11 2.912a.767.767 0 00-.021-.604.77.77 0 00-.438-.411.809.809 0 00-.571 0L7.655 8.909a.835.835 0 00-.277.181h-.006zm13.224-.812l.064-.048-.064.048zm-.87-.909s-.027.033-.038.054l.038-.054zM8.773 18.049L.231 26.6a.786.786 0 000 1.11l.003.005a.784.784 0 001.11 0l8.543-8.553a.786.786 0 000-1.11l-.004-.005a.784.784 0 00-1.11 0zM5.067 17.261L1.813 20.52a.786.786 0 000 1.11l.003.005a.784.784 0 001.11 0l3.254-3.258a.786.786 0 000-1.111l-.004-.004a.784.784 0 00-1.11 0zM7.922 23.398l-3.254 3.257a.786.786 0 000 1.111l.004.004a.784.784 0 001.11 0l3.254-3.257a.786.786 0 000-1.112l-.004-.003a.784.784 0 00-1.11 0z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_106_1747"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h28v28H0z"}})])])])
          )
        }
      }
    